import { useRecoilValue } from 'recoil'
import parametersSelectors from '../../pages/Parameters/parameters.selectors.ts'
import { useEffect } from 'react'
import ws from './index.ts'

/*
 * Системный хук, поддерживающий список параметров в экземпляре класса WSClient актуальным
 */
const useWsClientParametersSubscription = () => {
  const data = useRecoilValue(parametersSelectors.getSourceIdToParameterMap)

  useEffect(() => {
    ws.setParametersRecord(data)
  }, [data])
}

export default useWsClientParametersSubscription
